import React, { useEffect, useRef, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Box,
    Divider,
    Stack,
    Grid,
    Typography,
    Input,
    Button,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Drawer,
    TableBody,
    Modal,
    Autocomplete,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId } from "../../../utils/Constant";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
// import CustomDataGrids from "../../../utils/CustomDataGrids";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import DataGrids from "../../../utils/Datagrids";
import { format } from 'date-fns';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {
    GoogleMap,
    InfoWindow,
    LoadScript,
    Marker,
} from "@react-google-maps/api";


import VisibilityIcon from '@mui/icons-material/Visibility';
import nopdf from '../../../assets/images/imagepreview.jpg';
import PrintIcon from '@mui/icons-material/Print';


import jsPDF from "jspdf";
import * as XLSX from "xlsx";


interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}


const containerStyle = {
    width: "100%",
    height: "450px",
};


const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95%",
    height: "85%",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};

export default function MrnReport() {
    const Userid = getId();
    let navigate = useNavigate();
    const [IsShow, setShow] = useState(false);
    const [zones, setZones] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);


    const [swipModal, setSwipModal] = useState(false);
    const { t } = useTranslation();

    const [swipData, setSwipData] = useState<any>([]);
    const [Option, setOption] = useState([
        { value: "-1", label: t("text.SelectMRN") },
    ]);

    const [Option1, setOption1] = useState([
        { value: "-1", label: t("text.SelectVendor") },
    ]);

    const [taxOption, setTaxOption] = useState([
        { value: "-1", label: t("text.SelectPurchaseOrder") },
    ]);


    const [Shows, setShows] = useState<boolean>(false);
    const [IsRep, setRep] = useState<any>("");

    const [selectedFormat, setSelectedFormat] = useState<any>("pdf");
    const [isPrint, setPrint] = useState([]);
    const [isHovered, setIsHovered] = useState(false);




    const handlePrint = async (Id: any) => {
        const collectData = {
            "mrnId": Id,
            "mrnNo": "",
            "vendorId": -1,
            "purOrderId": -1,
            "fromDate": null,
            "toDate": null,
            "show": false,
            "exportOption": ".pdf",
            "type": 1
        };
        // console.log("collectData " + JSON.stringify(collectData));
        const response = await api.post(
            `Mrn/GetMrn`,
            collectData
        );


        if (response) {


            //console.log('Printdata',data)
            setShows(true);
            setRep(response.data);

        }
    };





    useEffect(() => {
        // fetchZonesData();

        getMRN();

        getPurchaseData();
        getVendor();
    }, []);




    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFormat((event.target as HTMLInputElement).value);
    };

    const downloadTabularExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Tabular HTML.");
            return;
        }

        // Prepare headers and rows for HTML table
        const headers = [
            "MRN No.",
            "MRN Date",
            "MRN Type",
            "Bill/Chalan No",
            "Bill/Chalan Date",
            "Shipment No.",
            "Total Amount",
            "Gross Amount",
            // "Voucher Type",
            // "In Quantity",
            // "Out Quantity",
        ];

        const rows = isPrint.map((item: any, index: any) => [

            item?.mrnNo || "",
            item.mrnDate.slice(0, 10),
            item?.mrnType === '1' ? 'Bill' : 'Challan',
            item?.bill_ChalanNo || "",

            item.bill_ChalanDate.slice(0, 10),
            item?.shipmentNo || "",
            item?.totalAmount || "",
            item?.totalGrossAmount || "",
        ]);

        // Create HTML table with enhanced styles and icons
        let html = `
          <html>
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>MRN Report</title>
              <!-- Include FontAwesome icons for visuals -->
              <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
              <style>
                body {
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  background-color: #f0f4f7;
                  color: #333;
                  margin: 0;
                  padding: 0;
                }
                .report-container {
                  width: 95%;
                  max-width: 1200px;
                  margin: 40px auto;
                  background-color: #ffffff;
                  border-radius: 10px;
                  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                  padding: 40px;
                  padding-bottom: 60px;
                }
                .header {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 30px;
                }
                .logo {
                  max-width: 150px;
                  height: auto;
                }
                .header-title {
                  text-align: center;
                  color: #1a73e8;
                  font-size: 28px;
                  font-weight: 600;
                  flex-grow: 1;
                }
                .generated-date {
                  color: #888;
                  font-size: 14px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 30px;
                }
                th {
                  background-color: #1a73e8;
                  color: white;
                  font-weight: bold;
                  padding: 16px;
                  text-align: left;
                  border: 1px solid #ddd;
                  text-transform: uppercase;
                }
                td {
                  padding: 12px;
                  text-align: left;
                  border: 1px solid #ddd;
                  font-size: 16px;
                  color: #333;
                }
                tr:nth-child(even) {
                  background-color: #f7f7f7;
                }
                tr:hover {
                  background-color: #f1f1f1;
                }
                .footer {
                  text-align: center;
                  font-size: 14px;
                  color: #888;
                  margin-top: 40px;
                }
                .footer a {
                  color: #1a73e8;
                  text-decoration: none;
                }
                .footer a:hover {
                  text-decoration: underline;
                }
                .page-footer {
                  font-size: 12px;
                  color: #aaa;
                  margin-top: 40px;
                }
              </style>
            </head>
            <body>
              <div class="report-container">
                <!-- Header Section: Logo, Title, Date -->
                <div class="header">
                  <img class="logo" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQb4HkK_VJ8hgOaOz_hcsBXPslnFWgCrfxFg&s" alt="Company Logo">
                  <div class="header-title">MRN Report</div>
                  <div class="generated-date">
                    Generated on: ${new Date().toLocaleDateString("en-GB")}
                  </div>
                </div>
                
                <!-- Table Section -->
                <table>
                  <thead>
                    <tr>
                      ${headers.map((header) => `<th>${header}</th>`).join("")}
                    </tr>
                  </thead>
                  <tbody>
                    ${rows
                .map(
                    (row: any) =>
                        `<tr>${row
                            .map(
                                (cell: any) =>
                                    `<td>${cell}</td>`
                            )
                            .join("")}</tr>`
                )
                .join("")}
                  </tbody>
                </table>
                
                <div class="footer">
                  <p>Company Name | <a href="mailto:support@company.com">Contact Us</a></p>
                </div>
              </div>
            </body>
          </html>
        `;

        // Create a Blob from the HTML string and trigger the download
        const blob = new Blob([html], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "MRN_Report_tabular.html";
        link.click();
    };



    const downloadExcel = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to Excel.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(isPrint);

        const headers = Object.keys(isPrint[0]);

        headers.forEach((header, index) => {
            const cellAddress = `${String.fromCharCode(65 + index)}1`;
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "reports");

        XLSX.writeFile(wb, "MRN_Report.xlsx");
    };

    // Function to download PDF

    // Handle Download Button Click
    const handleDownload = () => {
        if (selectedFormat === "excel") {
            downloadExcel();
        } else if (selectedFormat === "pdf") {
            downloadPDF();
        } else if (selectedFormat === "tabular") {
            downloadTabularExcel();
        }
    };

    const downloadPDF = () => {
        if (!isPrint || isPrint.length === 0) {
            console.error("No data to export to PDF.");
            return;
        }

        // Initialize jsPDF with 'landscape' orientation
        const doc = new jsPDF("landscape"); // This sets the page orientation to landscape
        let yPosition = 10;
        const headerFontSize = 14;
        const bodyFontSize = 12;

        doc.setFontSize(headerFontSize);
        doc.setFont("helvetica", "bold");
        doc.text("Vehicle Data", 14, yPosition);
        yPosition += 10;

        const headers = ["MRN No.", "MRN Date", "MRN Type", "Bill/Chalan No.", "Bill/Chalan Date", "Shipment No", "Total Amount", "Gross Amount"];

        const columnWidths = [50, 50, 50, 50, 50, 50, 50, 50];

        const headerHeight = 8;
        const headerY = yPosition;
        doc.setFillColor(200, 220, 255);
        doc.rect(
            14,
            headerY,
            columnWidths.reduce((a, b) => a + b, 0),
            headerHeight,
            "F"
        );

        doc.setFont("helvetica", "bold");
        headers.forEach((header, index) => {
            doc.text(
                header,
                14 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
                yPosition + headerHeight - 2
            );
        });

        const headerBottomMargin = 6;
        yPosition += headerHeight + headerBottomMargin;

        // Add table rows
        doc.setFontSize(bodyFontSize);
        doc.setFont("helvetica", "normal");

        isPrint.forEach((item: any, rowIndex) => {
            const row = [

                item?.mrnNo || "",

                item.mrnDate.slice(0, 10),
                item?.mrnType=== '1' ? 'Bill' : 'Challan' ,
                item?.bill_ChalanNo || "",

                item.bill_ChalanDate.slice(0, 10),
                item?.shipmentNo || "",
                item?.totalAmount || "",

                item.totalGrossAmount,


            ];

            row.forEach((cell, colIndex) => {
                const xOffset =
                    14 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
                if (cell) {
                    doc.text(cell.toString(), xOffset, yPosition);
                }
            });
            yPosition += 10;

            if (yPosition > 180) {
                // Adjust this to your content size for landscape
                doc.addPage();
                yPosition = 10; // Reset position on new page
            }
        });

        // Save the generated PDF with a filename
        doc.save("MRN_Report.pdf");
    };


    const getMRN = async () => {
        const collectData = {
            "mrnId": -1,
            "mrnNo": "",
            "vendorId": -1,
            "purOrderId": -1,
            "fromDate": null,
            "toDate": null,
            "show": true,
            "exportOption": "",
            "type": 0
        };
        const res = await api.post(`Mrn/GetMrn`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.mrnNo,
                value: item.mrnId,
            })) || [];

        setOption(arr);
    };



    const getVendor = async () => {
        const collectData = {
            "venderId": -1,

        };
        const res = await api.post(`VendorMaster/Ge3tVendorMaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.name,
                value: item.venderId,
            })) || [];

        setOption1(arr);
    };

    const getPurchaseData = async () => {
        const collectData = {
            purchaseID: -1,
            deptID: -1
        };
        const res = await api.post(`PurchaseOrder/GetPurchaseOrder`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.purchaseNo,
                value: item.purchaseID,
            })) || [];

        setTaxOption(arr);
    };








    // Fetch the vehicle data from API






    const getSwipDataPole = async (Id: any) => {
        setSwipModal(true);
        try {

            const collectData = {
                "mrnId": Id,
                "mrnNo": "",
                "vendorId": -1,
                "purOrderId": -1,
                "fromDate": null,
                "toDate": null,
                "show": true,
                "exportOption": "",
                "type": 0
            };


            const response = await api.post(
                `Mrn/GetMrn`, collectData
            );
            const data = response.data.data[0]?.mrnDetail;

            setSwipData(data)

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };




    const formik = useFormik({
        initialValues: {

            "zoneId": -1,
            "wordId": -1,
            fromDate: null,
            toDate: null,
            mrnNo: "",
            vendorId: -1,
            purOrderId: -1


        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {

        },
    });


    const fetchZonesData = async () => {
        setShow(true);
        try {

            const collectData = {
                "mrnId": -1,
                "mrnNo": formik.values.mrnNo,
                "vendorId": formik.values.vendorId,
                "purOrderId": formik.values.purOrderId,
                "fromDate": formik.values.fromDate,
                "toDate": formik.values.toDate,
                "show": true,
                "exportOption": "",
                "type": 0
            }
            const response = await api.post(
                // `Mrn/GetMrn`,{headers:{'MrnId': '-1'}}
                `Mrn/GetMrn`, collectData
            );
            const data = response.data.data;


            const Print = data.map((item: any, index: any) => ({
                ...item,
            }));
            setPrint(Print);
            const IndentWithIds = data.map((Item: any, index: any) => ({
                ...Item,
                serialNo: index + 1,
                id: Item.mrnId,
            }));
            setZones(IndentWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [






                    {
                        field: "mrnNo",
                        headerName: t("text.mrnNo"),
                        renderCell: (params) => {
                            return (
                                <div
                                    style={{ cursor: 'pointer', color: "blue" }}
                                    onClick={() => getSwipDataPole(params.row.id)}
                                >
                                    {params.value}
                                </div>
                            );
                        },
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {

                        field: "mrnDate",
                        headerName: t("text.mrnDate"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        valueFormatter: (params) => {
                            const date = new Date(params.value);
                            return date ? format(date, 'dd-MM-yyyy') : '__';
                        },
                    },
                    {
                        field: "mrnType",
                        headerName: t("text.mrnType"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        renderCell(params) {
                            return params.row.mrnType === '1' ? 'Bill' : 'Challan';
                        },
                    },
                    {
                        field: "bill_ChalanNo",
                        headerName: t("text.bill_ChalanNo"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "bill_ChalanDate",
                        headerName: t("text.bill_ChalanDate"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        valueFormatter: (params) => {
                            const date = new Date(params.value);
                            return date ? format(date, 'dd-MM-yyyy') : '__';
                        },

                    },
                    {
                        field: "shipmentNo",
                        headerName: t("text.shipmentNo"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "totalAmount",
                        headerName: t("text.totalAmount"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    // {
                    //   field: "netAmount",
                    //   headerName: t("text.NetAmounts"),
                    //   flex: 1,
                    //   headerClassName: "MuiDataGrid-colCell",
                    //   renderCell(params) {
                    //     // console.log("values", params.row);
                    //     return parseFloat(params.row.totalCGST )+ parseFloat(params.row.totalSGST)
                    //   },
                    // }, 
                    {
                        field: "totalGrossAmount",
                        headerName: t("text.totalGrossAmounts"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },

                    {
                        field: "actions",
                        headerClassName: "MuiDataGrid-colCell",
                        headerName: t("text.Print"),
                        width: 75,

                        renderCell: (params) => {
                            return [
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    sx={{ alignItems: "center", marginTop: "5px" }}
                                >


                                    <PrintIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "#65b7c9",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            handlePrint(params.row.id);
                                        }}
                                    />
                                </Stack>,
                            ];
                        },
                    },
                ];
                setColumns(columns as any);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            // setLoading(false);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));



    return (
        <>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "lightgreen",
                    border: ".5px solid #2B4593",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Grid item xs={12} container spacing={1}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="left"
                            >
                                {t("text.MrnDetailsReport")}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} classes="my-2 mb-2">

                        {/* <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
                size="large"
                style={{backgroundColor:`var(--header-background)`}}
              >
                {t("text.add")}
              </Button> */}

                    </Stack>


                    <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        sx={{ marginTop: "1%" }}
                    >
                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={Option}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("mrnNo", newValue?.label);
                                    // formik.setFieldValue("zoneName", newValue?.label);
                                    // getWardData(newValue?.value)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectMRN")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />

                        </Grid>


                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={taxOption}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("purOrderId", newValue?.value);
                                    //formik.setFieldValue("wardName", newValue?.label);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectPurchaseOrder")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item sm={4} lg={4} xs={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={Option1}
                                //   value={
                                //     Option.find(
                                //       (option: any) => option.value === formik.values.stateId
                                //     ) || null
                                //   }
                                fullWidth
                                size="small"
                                onChange={(event, newValue: any) => {
                                    console.log(newValue?.value);

                                    formik.setFieldValue("vendorId", newValue?.value);
                                    // formik.setFieldValue("zoneName", newValue?.label);
                                    // getWardData(newValue?.value)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <CustomLabel
                                                text={t("text.SelectVendor")}
                                                required={false}
                                            />
                                        }
                                    />
                                )}
                            />

                        </Grid>




                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.FromDate")} />}
                                value={formik.values.fromDate}
                                name="fromDate"
                                id="fromDate"
                                placeholder={t("text.FromDate")}
                                size="small"
                                fullWidth
                                type="date"
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item sm={4} lg={4} xs={12}>
                            <TextField
                                label={<CustomLabel text={t("text.ToDate")} />}
                                value={formik.values.toDate}
                                name="toDate"
                                id="toDate"
                                placeholder={t("text.ToDate")}
                                type="date"
                                size="small"
                                fullWidth
                                style={{ backgroundColor: "white" }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>




                        <Grid item xs={12} lg={4}>

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth={true}
                                style={{
                                    // width: "60%",

                                    backgroundColor: `var(--header-background)`,
                                    //margin: "1%",
                                }}
                                onClick={() => {
                                    fetchZonesData();

                                }}
                            >
                                {t("text.show")}
                            </Button>
                        </Grid>


                        



                        <Grid item xs={12} lg={3.5}></Grid>


                        <Grid item xs={12} sm={4} lg={4}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    value={selectedFormat}
                                    onChange={handleFormatChange}
                                >
                                    <FormControlLabel
                                        value="pdf"
                                        control={<Radio />}
                                        label="PDF"
                                    />
                                    <FormControlLabel
                                        value="excel"
                                        control={<Radio />}
                                        label="Excel"
                                    />
                                    <FormControlLabel
                                        value="tabular"
                                        control={<Radio />}
                                        label="Tabular Excel"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>



                        <Grid
                            item
                            xs={12}
                            sm={1}
                            lg={1}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={handleDownload}
                        >
                            <PrintIcon
                                style={{ color: isHovered ? "black" : "blue" }}
                                fontSize="large"
                            />
                        </Grid>
                    </Grid>


                    <Grid item xs={12} lg={3.5}></Grid>











                    {IsShow && (

                        <Grid xs={12} lg={12} sm={12} item>

                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : (
                                <DataGrids
                                    isLoading={isLoading}
                                    rows={zones}
                                    columns={adjustedColumns}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    initialPageSize={5}
                                />
                            )}


                            <Modal open={Shows} onClose={() => setShows(false)}>
                                <Box sx={style}>
                                    {IsRep ? (
                                        <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
                                    ) : (
                                        <img
                                            src={nopdf}
                                            alt="No Preview"
                                            style={{ width: "100%", height: "100%" }}
                                        />
                                    )}
                                </Box>
                            </Modal>

                        </Grid>
                    )}



                    <Grid xs={12} lg={12} sm={12} item>
                        <Drawer
                            anchor="right"
                            style={{ zIndex: 1400 }}
                            open={swipModal}
                            onClose={() => setSwipModal(false)}
                        >
                            {/* Drawer content */}
                            <div style={{ width: '700px', padding: '20px', backgroundColor: '#f4f7fc' }}>
                                {/* Header with color */}
                                <div
                                    style={{
                                        backgroundColor: '#1976D2', // Blue color for header
                                        color: '#fff',
                                        padding: '15px 20px',
                                        borderRadius: '8px 8px 0 0',
                                        textAlign: 'center',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    M.R.N Item Details
                                </div>

                                {/* Table container with better padding and spacing */}
                                <TableContainer style={{ marginTop: '20px' }}>
                                    <Table style={{ minWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd', // Light blue for header background
                                                        fontWeight: 'bold',
                                                        color: '#1976D2', // Blue text color
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap', // Prevent text wrapping in header
                                                    }}
                                                >
                                                    {t("text.ItemName")}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.unit")}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.BalQty")}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.ApproveQty")}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.Rate")}
                                                </TableCell>

                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.Amount")}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.GSTRate")}
                                                </TableCell>

                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.totalTax")}
                                                </TableCell>

                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#e3f2fd',
                                                        fontWeight: 'bold',
                                                        color: '#1976D2',
                                                        textAlign: 'center',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {t("text.NetAmount")}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {swipData.map((item: any) => (
                                                <TableRow key={item.poleInstChildId}>
                                                    <TableCell style={{ textAlign: 'left' }}>{item.itemName}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>
                                                        {item.unitName}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.balQuantity}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.quantity}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.rate}</TableCell>


                                                    <TableCell style={{ textAlign: 'left' }}>{item.amount}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.gstRate}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.totalGst}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{item.netAmount}</TableCell>



                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Drawer>
                    </Grid>




                </Paper>
            </Card>
            <ToastApp />
        </>
    );
}
